import DOMPurify from 'dompurify'

const ALLOWED_TAGS = ['p', 'br', 'b', 'i', 'em', 'strong', 'a', 'ul', 'ol', 'li',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'div', 'table', 'thead',
    'tbody', 'tr', 'td', 'th', 'img', 'blockquote', 'pre', 'code', 'hr', 'sub', 'sup']

const ALLOWED_ATTR = ['href', 'src', 'alt', 'class', 'style', 'target', 'rel',
    'colspan', 'rowspan', 'width', 'height']

export function sanitize(html) {
    if (!html) return ''
    return DOMPurify.sanitize(html, {
        ALLOWED_TAGS,
        ALLOWED_ATTR,
        ALLOW_DATA_ATTR: false,
    })
}
